import { Action } from "../../../common/actions/core/action";
import { ListeningPackageSegment } from "../../../common/services/package/package.model";

export class NoAuthBuySuccessAction implements Action {
  constructor(public type: ListeningPackageSegment) {}
}



// WEBPACK FOOTER //
// src/app/no-auth/components/buy-success-dialog/buy-success-dialog.action.ts